import { Component, OnInit, OnDestroy } from '@angular/core';
import { Press } from '../../interfaces/press-page';
import { ActivatedRoute } from '@angular/router';
import { MetaDataService } from '../../services/metadata.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-page-press',
  templateUrl: './page-press.component.html',
  styleUrls: ['./page-press.component.scss']
})
export class PagePressComponent implements OnInit, OnDestroy {
  page$;
  content: Press;

  constructor(
    private route: ActivatedRoute,
    private mds: MetaDataService
  ) {
    // Get page content
    this.page$ = this.route.data.pipe(map(r => r.content));
    this.page$.subscribe(page => {
      this.content = page;

      // set metadata
      this.mds.setMetaData(this.content);
    });
  }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  ngOnDestroy() {
    if (this.page$) {
      this.page$.unsubscribe();
    }
  }
}
